








import { Getter, Mutation } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import Landing from '@/shared/views/Landing.vue';
import Signup from '@/shared/views/Signup.vue';
import { ApiService } from '@/shared/services/ApiService';
import { SignupData } from '@/shared/store/types';


@Component({
  components: {
    Landing,
    Signup,
  },
})

export default class EconomicSignupProcess extends Vue {
  errors: object = {};

  submitting: boolean = false;

  @Getter('getStep') step!: number;

  @Mutation('setSignupData') setSignupData: any;

  @Mutation('nextStep') next: any;

  @Mutation('previousStep') previous: any;

  async mounted() {
    await this.load();
  }

  private async load() {
    this.setSignupData({
      signupType: 'standard',
      orgName: null,
      orgCVR: null,
      orgType: null,
      personName: null,
      personEmail: null,
      personPhone: null,
      acceptedTermsAndAgreements: false,
      receiveNewsletters: false,
    });
  }

  submit(data: SignupData) {
    const signupData = data;

    this.submitting = true;

    ApiService.post('signup-api/v1/signup', signupData)
      .then((response) => {
        const {
          data: {
            data: {
              redirect_url: redirectUrl,
            },
          },
        } = response;

        this.submitting = false;

        window.location.href = redirectUrl;
      })
      .catch(({ response }) => {
        this.submitting = false;

        if (response.status === 422) {
          this.errors = response.data;
          window.scroll(0, 0);
        }
      });
  }
}
